module.exports = __webpack_public_path__ + "static/media/mobile_logo@2x.e309e3b5.png";